import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useMemo } from 'react';
import { FillInBlankInput } from './fill-in-blank-input.component';
import { FillInBlankAnswerPreview } from './fill-in-blank-answer-preview.component';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var InlineHTMLSpan = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline;\n\n  p {\n    display: inline;\n    margin: 0;\n  }\n\n  img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n"])));
var StyledFillInBlankDescription = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: #1e293b;\n  line-height: ", ";\n  font-weight: 400;\n  letter-spacing: 0;\n  cursor: pointer;\n\n  p {\n    margin: 0;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), getSize('typo14'), getSize('padding20'));
/**
 * Parse HTML string and replace <fib-blank> tags with React components
 * Returns an array of React elements and strings that can be rendered
 * Index is auto-incremented based on order of appearance (1, 2, 3...)
 */

var parseHTMLWithBlanks = function parseHTMLWithBlanks(html, answers, startQuestionIndex, onAnswer, readOnly, question, isShowCorrectAnswer) {
  var regex = /<fib-blank\s+[^>]*id="([^"]+)"[^>]*>/g;
  var parts = [];
  var lastIndex = 0;
  var match;
  var keyCounter = 0;
  var blankCounter = startQuestionIndex; // Auto-increment counter for blank indices

  var _loop = function _loop() {
    var _match = match,
        _match2 = _slicedToArray(_match, 2),
        fullMatch = _match2[0],
        uuid = _match2[1]; // Fix: regex only has 1 capture group, so uuid is match[1]


    var matchIndex = match.index; // Add HTML content before the match

    if (matchIndex > lastIndex) {
      var htmlBefore = html.substring(lastIndex, matchIndex);

      if (htmlBefore.trim()) {
        parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
          dangerouslySetInnerHTML: {
            __html: htmlBefore
          }
        }, "html-".concat(keyCounter++)));
      }
    } // Get answer description for this blank (split by "|" to get tags)


    var answerTags = [];

    if (question) {
      var _fibQuestion$answers;

      var fibQuestion = question;
      var answer = fibQuestion === null || fibQuestion === void 0 ? void 0 : (_fibQuestion$answers = fibQuestion.answers) === null || _fibQuestion$answers === void 0 ? void 0 : _fibQuestion$answers.find(function (ans) {
        return ans.id.toString() === uuid;
      });

      if (answer !== null && answer !== void 0 && answer.description) {
        // Split by "|" delimiter and filter out empty strings
        answerTags.push.apply(answerTags, _toConsumableArray(answer.description.split('|').map(function (tag) {
          return tag.trim();
        }).filter(function (tag) {
          return tag.length > 0;
        })));
      }
    } // Render either select component or input component based on isShowCorrectAnswer


    if (isShowCorrectAnswer) {
      parts.push( /*#__PURE__*/_jsx(FillInBlankAnswerPreview, {
        index: blankCounter++,
        answerId: uuid,
        question: question
      }, uuid));
    } else {
      parts.push( /*#__PURE__*/_jsx(FillInBlankInput, {
        index: blankCounter++,
        uuid: uuid,
        value: answers[uuid] || '',
        onChange: function onChange(val) {
          return onAnswer === null || onAnswer === void 0 ? void 0 : onAnswer(uuid, val);
        },
        readOnly: readOnly,
        answerTags: answerTags
      }, uuid));
    }

    lastIndex = matchIndex + fullMatch.length;
  };

  while ((match = regex.exec(html)) !== null) {
    _loop();
  } // Add remaining HTML content after the last match


  if (lastIndex < html.length) {
    var htmlAfter = html.substring(lastIndex);

    if (htmlAfter.trim()) {
      parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
        dangerouslySetInnerHTML: {
          __html: htmlAfter
        }
      }, "html-".concat(keyCounter++)));
    }
  } // If no matches found, render the entire HTML as-is


  if (parts.length === 0 && html.trim()) {
    parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }, "html-full"));
  }

  return parts;
};

export var FillInBlankDescription = function FillInBlankDescription(_ref) {
  var description = _ref.description,
      _ref$answers = _ref.answers,
      answers = _ref$answers === void 0 ? {} : _ref$answers,
      onAnswer = _ref.onAnswer,
      startQuestionIndex = _ref.startQuestionIndex,
      readOnly = _ref.readOnly,
      question = _ref.question,
      _ref$isShowCorrectAns = _ref.isShowCorrectAnswer,
      isShowCorrectAnswer = _ref$isShowCorrectAns === void 0 ? false : _ref$isShowCorrectAns;
  var renderedParts = useMemo(function () {
    return parseHTMLWithBlanks(description, answers, startQuestionIndex, onAnswer, readOnly, question, isShowCorrectAnswer);
  }, [description, answers, onAnswer, readOnly, question, startQuestionIndex, isShowCorrectAnswer]);
  return /*#__PURE__*/_jsx(StyledFillInBlankDescription, {
    children: renderedParts
  });
};